module.exports = __webpack_public_path__ + "b6cc1420b41e6855de3f764c6c46c203.jpg";